import styled from "@emotion/styled";

export const Container = styled.span``;

export const Separator = styled.span`
  white-space: pre;
`;
